import styled from "styled-components";
export const Container = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;
export const Main = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const PaymentContainer = styled.div`
    height: 100vh;
    width: 100%;
`;

export const PaymentContent = styled.div`
    position: relative;
    height: 100vh;
`;
